<div class="payment-item-container">
  <div class="content" (click)="paymentMethodSelected()">
    <div class="item {{ selected ? 'selected' : '' }}">
      <div class="headline">
        <kion-radio (selected)="paymentMethodSelected()" [selected]="selected"></kion-radio>
       <span> {{ paymentMethod.name }} </span>
      </div>
      <div class="description">
        {{ paymentMethod.description }}
      </div>
      <div class="iframe {{hasIframe ? '' : 'disabled'}} {{ selected ? '' : 'disabled' }}">
        <ng-content select="[iframe]"></ng-content>
      </div>
      <div class="po-field">
        <ng-content select="[poField]"></ng-content>
      </div>
    </div>
  </div>
</div>
